import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { AdviserModel }         from './typings/adviser';
import { AdvisersService }      from './advisers.service';
import { EditComponent }        from '../table/cell-components/actions/edit.component';
import { Table }                from '../table/types/table';
import { TableQueryParameters } from '../table/types/table-query-parameters';
import { TableService }         from '../table/table.service';

@Component({
  selector   : 'wor-advisers',
  template: require('./advisers.component.html')
})
export class AdvisersComponent {
  @Input() advisers: Array<AdviserModel>;

  tableCacheKey = 'advisers';

  tableSettings : Table = {
    cache: {
      enabled: true,
      key    : this.tableCacheKey
    },
    columns: [
      {
        field : 'display_name',
        header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.NAME') }
      },
      {
        field : 'phone',
        header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.PHONE_NUMBER') },
        pipe  : 'mobilePhone'
      },
      {
        field : 'email',
        header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.EMAIL') }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: ( adviser : AdviserModel ) => this.view(adviser)
            }
          },
          enabled: true,
          factory: EditComponent },
        sortable: false }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_ADVISERS')
    },
    pagination: {
      enabled   : true,
      pageSize  : this.tableService.getCachedPaging(this.tableCacheKey).pageSize || 10,
      pageSizes : [ 10, 20, 50, 100 ],
      queryCount: () => this.advisersService.getCount()
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: this.tableService.setSortingFromCache(this.tableCacheKey, {
      direction: 'asc',
      field    : 'display_name'
    })
  };

  constructor (
    private advisersService : AdvisersService,
    private router          : UIRouter,
    private tableService    : TableService,
    private translateService: TranslateService
  ) {}

  get ( params : TableQueryParameters ) : void {
    this.advisersService.get(params)
    .then(advisers => {
      this.advisers = advisers;

      return advisers;
    });
  }

  view ( adviser : AdviserModel ) : void {
    this.router.stateService.go('app.adviser', {
      id: adviser.id
    });
  }
}
